module.exports = __webpack_public_path__ + "static/assets/50628a3bc8d221029d09fecbb9956863.gif";